import { css } from '@emotion/react';

export const opacityStyle = {
  translucent: css`
    opacity: 0.7;
  `,
};
